var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTradeIn = function SvgTradeIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.499 7.396a.4.4 0 0 1-.283.49l-1.45.389a.9.9 0 0 1-1.101-.637L2.276 6.19a.4.4 0 0 1 .773-.207l.388 1.45a.1.1 0 0 0 .123.07l1.449-.388a.4.4 0 0 1 .49.282ZM14.801 12.479a.4.4 0 0 1 .283-.49l1.449-.389a.9.9 0 0 1 1.102.637l.388 1.449a.4.4 0 1 1-.772.207l-.389-1.45a.1.1 0 0 0-.122-.07l-1.449.388a.4.4 0 0 1-.49-.282Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.4a6.603 6.603 0 0 0-6.327 4.714l-.766-.228A7.4 7.4 0 0 1 17.4 10h-.8A6.6 6.6 0 0 0 10 3.4ZM10.29 16.6a6.603 6.603 0 0 0 6.327-4.714l.766.228A7.4 7.4 0 0 1 2.89 10h.8a6.6 6.6 0 0 0 6.6 6.6Z",
    fill: "currentColor"
  })));
};
export default SvgTradeIn;